"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionDropdown = void 0;
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../../../foundations");
const useDynamicDropdownHeight_1 = require("./hooks/useDynamicDropdownHeight");
const Option_1 = require("./Option");
const OptionList = ({ dropdownOptions, focusedIdx, showTopOverlay, showBottomOverlay }) => {
    if (!dropdownOptions || dropdownOptions.length === 0) {
        return null;
    }
    const options = dropdownOptions.map((option, idx, array) => {
        return (react_1.default.createElement(Option_1.Option, { key: option.value, option: option, isFocused: focusedIdx === idx, idx: idx, lastOption: idx === array.length - 1 }));
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        options,
        react_1.default.createElement(foundations_1.Box, { sx: {
                position: "absolute",
                borderRadius: "medium",
                top: 0,
                left: 0,
                right: 0,
                height: showTopOverlay ? 15 : 0,
                background: "gradientTop",
                pointerEvents: "none",
                transition: "height 200ms ease-in"
            } }),
        react_1.default.createElement(foundations_1.Box, { sx: {
                position: "absolute",
                borderRadius: "medium",
                bottom: 0,
                left: 0,
                right: 0,
                height: showBottomOverlay ? 15 : 0,
                background: "gradientBottom",
                pointerEvents: "none",
                transition: "height 200ms ease-out"
            } })));
};
const OptionDropdown = ({ dropdownOptions, showNoResults, optionDisplayCount = 5, focusedIdx, noResultsMessage, sx }) => {
    const dropdownRef = react_1.default.useRef(null);
    // Hook to dynamically adjust the height of the dropdown
    const { showTopOverlay, showBottomOverlay, handleScroll } = (0, useDynamicDropdownHeight_1.useDynamicDropdownHeight)({
        dropdownOptions,
        dropdownRef,
        optionDisplayCount,
        showNoResults
    });
    return (react_1.default.createElement(foundations_1.Box, { sx: Object.assign({ background: "inputBackgroundColor", borderRadius: "medium", width: "100%", boxShadow: "boxShadow01", marginTop: 4, position: "absolute", zIndex: "dropdown" }, sx) },
        react_1.default.createElement(foundations_1.Box, { ref: dropdownRef, as: "ul", sx: {
                listStyle: "none",
                paddingLeft: 2,
                paddingRight: 2,
                overflowY: "auto",
                scrollbarWidth: "none",
                // @ts-ignore
                "::-webkit-scrollbar": {
                    display: "none"
                }
            }, onScroll: handleScroll }, showNoResults ? (react_1.default.createElement(foundations_1.Box, { sx: { padding: 5, textAlign: "center" } },
            react_1.default.createElement(foundations_1.Text, { sx: { color: "inputLabel" }, variant: "medium" }, noResultsMessage || "No results"))) : (react_1.default.createElement(OptionList, { dropdownOptions: dropdownOptions, focusedIdx: focusedIdx, showTopOverlay: showTopOverlay, showBottomOverlay: showBottomOverlay })))));
};
exports.OptionDropdown = OptionDropdown;
//# sourceMappingURL=OptionDropdown.js.map